/* eslint-disable */
import React from "react";
import { Link } from "react-router-dom";

import { assetImages } from "constants";

const UserCard = ({
  token,
  eventMemberData,
  serverUrl,
  onSelectMeeting,
  onSelectConnect,
  onViewConnect,
}) => {
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  return (
    <div className="col-lg-4 col-sm-6 mb-4">
      <div className="speaker_bx bg_white text-center">
        <div className="speaker_pic rounded-circle overflow-hidden mb-3">
          <img
            src={
              eventMemberData.image == ""
                ? assetImages.defaultUser
                : serverUrl + eventMemberData.image
            }
            alt=""
          />
        </div>
        <div className="speaker_info mb-3">
          <h3 className="mb-3">{eventMemberData.name}</h3>
          <h6 className="fs-sm text-primary">
            {eventMemberData.position}{" "}
            {eventMemberData.position !== "" && eventMemberData.company !== ""
              ? "at"
              : ""}{" "}
            {eventMemberData.company}
            <span className="d-block">{eventMemberData.country}</span>{" "}
          </h6>
        </div>

        {/* view details and meet */}
        {userInfo &&
          userInfo._id.toString() === eventMemberData.user._id.toString()}

        <div className="btns_group d-flex align-items-center justify-content-center gap-2">
          <Link
            to={`/user/details/${eventMemberData.user._id}`}
            className="btn primary-btn"
          >
            <i className="material-icons-outlined fs-lg">
              {userInfo &&
              userInfo._id.toString() === eventMemberData.user._id.toString()
                ? "account_circle"
                : token
                ? eventMemberData.isconnect
                  ? "verified"
                  : ""
                : ""}
            </i>
            View Details
          </Link>

          {userInfo &&
          userInfo._id.toString() ===
            eventMemberData.user._id.toString() ? null : (
            <Link
              to="#"
              className="btn"
              data-bs-toggle="modal"
              data-bs-target={token ? "#intial_meet_modal" : "#login_modal"}
              onClick={() => {
                if (token) {
                  onSelectMeeting(eventMemberData);
                }
              }}
            >
              Meet
            </Link>
          )}
        </div>
      </div>
    </div>
  );
};

export default UserCard;
